export function validateEmail(email) {
    if (!email || typeof email !== 'string') {
        return false;
    }
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
} 

/**
 * Turns an error thrown by services/api.js into a user-facing message
 * that says what actually went wrong and what the user can do about it.
 */
export function getSubmitErrorMessage(err) {
    const status = err?.status;

    if (err?.code === 'NETWORK_ERROR' || status === 0) {
        return "We couldn't reach our server. Please check your internet connection and try again.";
    }
    if (err?.code === 'CAPTCHA_FAILED' || err?.code === 'CAPTCHA_REQUIRED') {
        return 'The security check expired or did not complete. Please complete it again and resubmit.';
    }
    if (err?.code === 'CAPTCHA_UNAVAILABLE' || err?.code === 'CAPTCHA_MISCONFIGURED') {
        return 'Our security check is temporarily unavailable. Your message was not sent. Please try again in a few minutes.';
    }
    if (err?.code === 'VALIDATION_ERROR' && Array.isArray(err.details) && err.details.length > 0) {
        return `Please check your details: ${err.details.map((d) => d.message).join('; ')}.`;
    }
    if (status === 429) {
        return 'Too many attempts. Please wait a minute and try again.';
    }
    if (status >= 500) {
        return 'Something went wrong on our end and your message was not sent. Please try again later.';
    }
    return "We couldn't send your message. Please review the form and try again.";
}

export function validatePhone(phone) {
    if (!phone || typeof phone !== 'string') {
        return false;
    }
    return /^\d{10}$/.test(phone);
}